import React, { useContext, useEffect, useState } from "react";
// import Box from "@mui/material/Box";
// import Fab from "@mui/material/Fab";
import Container from "@mui/material/Container";
import SellIcon from "@mui/icons-material/Sell";
import instance from "../api/api";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AddShoppingCart from "@mui/icons-material/AddShoppingCart";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Button, CardActionArea, CardActions, Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
// import { makeStyles } from "@mui/styles";
// import { createMuiTheme } from '@mui/styles';
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import AspectRatio from "@mui/joy/AspectRatio";
import { Context } from "../context/ContextProvider";
import Paper from "@mui/material/Paper";
import CartItem from "../components/Cart/CartItem/CartItem";
import CartItemM from "../components/Cart/CartItemM";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import { Stepper, Step, StepLabel } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function Cart({ t }) {
  let navigate = useNavigate();

  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
  } = useContext(Context);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    // localStorage.getItem("dataKey") != null &&
    // console.log("totalPrice: ", totalPrice.toFixed(2));

    console.log("data: ", localStorage.getItem("Order"));
    localStorage.getItem("Order") != null &&
      setCartItems(JSON.parse(localStorage.getItem("Order")));

    console.log("cart item:", cartItmes);
  }, []);

  return (
    <Container style={{ paddingTop: 50, paddingBottom: 20 }}>
      <Box width="100%" height={"50px"} p="50px" pt="0px">
        <Stepper
          style={{ backgroundColor: "#F6F6F6" }}
          activeStep={activeStep}
          sx={{ m: "20px 0" }}
        >
          <Step>
            <StepLabel> </StepLabel>
          </Step>
          <Step>
            <StepLabel> </StepLabel>
          </Step>
        </Stepper>
      </Box>
      <Box>
        {cartItmes.map((item, key) => (
          <CartItemM
            key={key}
            item={item}
            addToCart={handleAddProduct}
            removeFromCart={handleRemoveProduct}
          />
        ))}
      </Box>
      {cartItmes.length > 0 ? (
        <Paper
          sx={{
            p: 2,
            margin: "auto",
            m: 2,
            // maxWidth: 500,
            flexGrow: 1,
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "#1A2027" : "#fff",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
              <Box display={"flex"}>
                {/* <IconButton> */}
                <SellIcon style={{ marginLeft: 10 }} />
                {/* </IconButton> */}
                <Typography variant="body1">المجموع:</Typography>
              </Box>
            </Grid>
            <Grid item xs={7.5} sm={9.2} md={9.7} lg={10} xl={10}></Grid>
            <Grid item xs={3.5} sm={1.8} md={1.3} lg={1} xl={1}>
              <Box>{totalPrice.toFixed(2)} ريال</Box>
            </Grid>
          </Grid>
        </Paper>
      ) : null}
      {cartItmes.length > 0 ? (
        <Box
          sx={{
            // p: 2,
            margin: "auto",
            m: 2,
            // maxWidth: 500,
            flexGrow: 1,
            // backgroundColor: (theme) =>
            //   theme.palette.mode === "dark" ? "#1A2027" : "#fff",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Button
                size="large"
                endIcon={<KeyboardBackspaceIcon />}
                fullWidth
                variant="text"
                sx={{
                  marginTop: 1,
                  backgroundColor: "green",
                  color: "white",
                  ":hover": {
                    bgcolor: "green", // theme.palette.primary.main
                    color: "white",
                  },
                }}
                onClick={() => {
                  if (
                    jwt_decode(localStorage.getItem("Token")).user === undefined
                  ) {
                    alert("لا يمكن الاستمرار بحساب التاجر");
                    localStorage.removeItem("Order")
                    localStorage.removeItem("CountCart")
                    navigate('/home')
                    window.location.reload(true);
                    // setTimeout(() => {
                    // }, 200);
                  } else {
                    setActiveStep(1);
                    localStorage.setItem("Price", totalPrice.toFixed(2));
                    navigate(`/checkout`);
                  }
                }}
              >
                استمرار
              </Button>
            </Grid>
          </Grid>
        </Box>
      ) : null}

      {cartItmes.length === 0 ? (
        <Box
          display="flex"
          alignItems="center"
          border={`1.5px solid #e2e1e1`}
          m="20px"
          p="2px 5px"
        >
          This is Cart is Empty ...
          <Button onClick={() => navigate(`/home`)}>back</Button>
        </Box>
      ) : null}

      <Box width="80%" m="100px auto 50px auto" height={"50px"} p="20px "></Box>
    </Container>
  );
}

// https://mulfet.com/checkout/mxqxGkdMO6NnXKo301VE7JzYQbX1xojWpLmWyAe9Zg2b48Dwr5BalRjZ
